import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getFirmwareById } from "../../actions/doctorActions";
import Loader from "../loader/Loader";
import { formatDateTime } from "../../helper";

export default function FirmwareDetail() {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.loginData.token);
  const { loading, firmware } = useSelector((state) => state.firmwareDevice);

  useEffect(() => {
    dispatch(getFirmwareById(token, params.id)).catch((error) => {
      toast.error("Error fetching firmware");
      history.push("/firmware");
    });
  }, [dispatch, token, params.id]);

  const handleBack = () => {
    window.history.back();
  };

  const renderInfoRow = (label, value, formatter = (val) => val) => (
    <div className="form-detail-row">
      <span className="form-detail-label">{label}</span>
      <span className="form-detail-value">
        {value ? formatter(value) : "N/A"}
      </span>
    </div>
  );

  const handleDownload = () => {
    if (firmware.path_to_folder) {
      window.open(firmware.path_to_folder, "_blank");
    }
  };

  if (loading) return <Loader />;
  if (!firmware) return <div>No firmware data available</div>;

  return (
    <div className="concussion-form-detail">
      <div className="d-header">
        <ArrowBackIcon
          fontSize="large"
          onClick={handleBack}
          className="back-detail"
        />
        <div>
          <h3>Firmware Details</h3>
          <p className="text-center mb-5">
            {formatDateTime(firmware.date_uploaded)}
          </p>
        </div>
      </div>

      <div className="form-details-container">
        <div className="details-section">
          <h4>Basic Information</h4>
          {renderInfoRow("Firmware Version", firmware.firmware_version)}
          {renderInfoRow("IOS Version", firmware.version)}
          {renderInfoRow("File Size (Bytes)", firmware.file_size)}
          {renderInfoRow(
            "Date Uploaded",
            firmware.date_uploaded,
            formatDateTime
          )}
        </div>

        <div className="details-section">
          <h4>Content Information</h4>
          {renderInfoRow("Changelog", firmware.changelog)}
          {renderInfoRow("Path to Folder", firmware.path_to_folder)}
          {renderInfoRow("Image Path", firmware.image_path)}
        </div>

        <div className="details-section">
          <h4>Actions</h4>
          <div className="form-detail-row">
            <span className="form-detail-label">Download</span>
            <span className="form-detail-value">
              <button
                className="btn btn-sm btn-primary"
                onClick={handleDownload}
                disabled={!firmware.path_to_folder}
              >
                Download Firmware
              </button>
            </span>
          </div>
        </div>

        <div className="details-section">
          <h4>Additional Information</h4>
          {renderInfoRow("Created At", firmware.created_at, formatDateTime)}
          {renderInfoRow("Updated At", firmware.updated_at, formatDateTime)}
        </div>
      </div>
    </div>
  );
}
